import React from 'react';
import HeroSection from './components/HeroSection';
import Images from './Images';

// Use ONLY your custom images
const customImages = [
  Images.car1,
  Images.car2,
  Images.car3,
];

function App() {
  return (
    <div className="App bg-black">
      <HeroSection customImages={customImages} />
    </div>
  );
}

export default App;